import { Divider } from './Components/Divider/Divider';

import {
  Container,
  BackButton,
  BackIcon,
  BackText,
  BreadcrumbsOuterContainer,
  BreadcrumbsInnerContainer,
  BreadcrumbAndDividerContainer,
  BreadcrumbText,
  BreadcrumbLink,
} from './Breadcrumbs.styled';

import type { BreadcrumbsProps } from './Breadcrumbs.typed';
import type { LinkType } from '../../Toolkit/Button/SharedLink';

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { breadcrumbs, goBack, inverted, className } = props;

  const linkType: LinkType = inverted ? 'INVERTED' : 'SECONDARY';

  return (
    <Container className={className}>
      <BackButton onClick={goBack} ofType={linkType} aria-label="Go back">
        <BackIcon aria-hidden="true" />
        <BackText color={inverted ? 'GREY_LIGHT' : 'GREY_DARKER'}>
          Back
        </BackText>
      </BackButton>

      <BreadcrumbsOuterContainer>
        <BreadcrumbsInnerContainer>
          {breadcrumbs.map(({ displayName, href, ...linkProps }, index) => {
            const displayDivider = breadcrumbs.length - 1 !== index;
            const defaultColor = index === 0 ? 'GREY_DARKER' : 'GREY_DARK';
            const color = inverted ? 'GREY_LIGHT' : defaultColor;
            const dividerColor = inverted ? 'GREY_LIGHT' : 'GREY_DARK';

            return (
              <BreadcrumbAndDividerContainer key={index}>
                {!href ? (
                  <BreadcrumbText color={color}>{displayName}</BreadcrumbText>
                ) : (
                  <BreadcrumbLink
                    data-testid={`${displayName}-breadcrumb`}
                    ofType={linkType}
                    href={href}
                    {...linkProps}
                  >
                    {displayName}
                  </BreadcrumbLink>
                )}
                {displayDivider && <Divider color={dividerColor} />}
              </BreadcrumbAndDividerContainer>
            );
          })}
        </BreadcrumbsInnerContainer>
      </BreadcrumbsOuterContainer>
    </Container>
  );
};

export { Breadcrumbs };
